// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback .p-dropdown-label.p-placeholder {
  color: #ffffff !important;
}

.Strain .p-dropdown-label.p-placeholder {
  color: #ffffff !important;
}
.Strain .p-dropdown-label {
  color: #ffffff !important;
}
.LogoButton .p-button.p-button-text.p-button-plain {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/TitleBar/TitleBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb","sourcesContent":[".Feedback .p-dropdown-label.p-placeholder {\n  color: #ffffff !important;\n}\n\n.Strain .p-dropdown-label.p-placeholder {\n  color: #ffffff !important;\n}\n.Strain .p-dropdown-label {\n  color: #ffffff !important;\n}\n.LogoButton .p-button.p-button-text.p-button-plain {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
